var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilters28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.21 6H25a1.5 1.5 0 0 1 0 3H13.21a4.001 4.001 0 0 1-7.42 0H3a1.5 1.5 0 1 1 0-3h2.79a4.001 4.001 0 0 1 7.42 0Zm9 13H25a1.5 1.5 0 0 1 0 3h-2.79a4.001 4.001 0 0 1-7.42 0H3a1.5 1.5 0 0 1 0-3h11.79a4.001 4.001 0 0 1 7.42 0Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters28);
export default __webpack_public_path__ + "static/media/filters_28.1d9ae870.svg";
export { ForwardRef as ReactComponent };